import { takeLatest } from 'redux-saga/effects';

import { GET_CREDIT_REVIEW_CONTRACT_DATA } from './creditReviewActions';
import { fetchCreditReviewContractDataSaga } from './creditReviewSaga';

export function* creditReviewWatchers() {
  yield takeLatest(GET_CREDIT_REVIEW_CONTRACT_DATA, fetchCreditReviewContractDataSaga);
}
